export const USER_LOGGED = 'user.LOGGED';
export const USER_REMEMBER = 'user.REMEMBER';